import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  IProgram,
  IProgramGridFilter,
  IProgramGridModel,
  ProgramModelForDropdown,
} from "./types";
import api from "utils/api";
import { endpoints } from "utils/endpoints";
import { IDropdownModel } from "common/models/IDropdownModel";
import { PostModel } from "common/models/BaseModel";
import { IListResponse } from "common/models/GridModels";
import { programView } from "../types/programView";

export const program = createQueryKeys("program", {
  list: (postModel: PostModel<IProgramGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<IListResponse<IProgramGridModel>>(
        endpoints.program.list,
        postModel
      ),
  }),

  getById: (Id: string | number) => ({
    queryKey: [Id],
    queryFn: () => api.get<IProgram>(`${endpoints.program.getById}/${Id}`),
  }),

  getProgramValues: () => ({
    queryKey: ["GetProgramValues"],
    queryFn: () =>
      api.get<IDropdownModel[]>(endpoints.program.getProgramValues),
  }),

  getViewById: (Id: string | number) => ({
    queryKey: ["modal", Id],
    queryFn: () => api.get<programView>(`${endpoints.program.view}/${Id}`),
  }),

  getProgramByInstituteDepartment: (model: ProgramModelForDropdown) => ({
    queryKey: ["getProgramByInstituteDepartment", model],
    queryFn: () =>
      api.post<IDropdownModel[]>(
        endpoints.program.getProgramValuesByInstituteDepartment,
        model
      ),
  }),
});
